import LicenseModal from './LicenseModal';
export default LicenseModal;